import { render, staticRenderFns } from "./PopupAIImageRiskRecommendation.vue?vue&type=template&id=f8981782&scoped=true"
import script from "./PopupAIImageRiskRecommendation.vue?vue&type=script&lang=js"
export * from "./PopupAIImageRiskRecommendation.vue?vue&type=script&lang=js"
import style0 from "./PopupAIImageRiskRecommendation.vue?vue&type=style&index=0&id=f8981782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8981782",
  null
  
)

export default component.exports